import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "app/services/auth.service";
import { LocalService } from "app/services/local.service";
import { PageService } from "app/services/page-service";

@Component({
  selector: "app-success",
  templateUrl: "./success.component.html",
})
export class successComponent implements OnInit {
  @Input() successContent: any;
  planRecord = {};
  planType = "monthly";
  activePlan = {};
  planDetails = {};
  loader = false;
  errorMessage = "";
  errorStatus = undefined;

  constructor(
    public service: PageService,
    public authService: AuthService,
    public router: Router,
    public localService: LocalService,
    public dialogRef: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.loader = true;
    this.errorStatus = this.successContent.message.status;
    // console.log(this.successContent);
    this.prepareErrorMessage();
  }

  prepareErrorMessage() {
    if (typeof this.successContent.message === "object") {
      this.errorStatus = this.successContent.message.status;
      console.log(this.errorStatus);
      this.successContent.message = "";
    }

  }

  close() {
    this.dialogRef.close({ success: false });
  }
}

